import moment from 'moment-timezone';

export function getDateTimeByOffset(offset: string) {
  const timezone = moment.tz.names().find(name => moment.tz(name).format('Z') === offset);
  return moment.tz(timezone).format('dddd, HH:mm z');
}
